export default __webpack_public_path__ + "static/bariq-nurlis-b9f0440772c05437bf2c110678c46c33.webp";